// ziven-bjxy-website forum entry
// 注册 /bjxy 路由 + 渲染 BjxyPage (10 section + 浅深双版)
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
// v0.2.0ebb16a0 (辉哥 2026-09-09 19:25 拍板): UserPage 行为已迁到 ziven-core v0.5.16 (modifyUserPage.js)
//   本扩展只负责 /bjxy 路由 + BjxyPage + bjxy 业务 (预约/教练/课程/评价)

// v0.2.0i.aa.c.19 改 (辉哥 2026-09-01 00:17 拍板): 撤 c.15-c.18 全部 4 commits (BjxyPage.jsx view() 渲染 li+button + ul 包裹 + 隐藏 placeholder + bjxy-mobile-cta 视觉 class)
//   现象: c.18 部署后 button DOM 跟 /all 1:1 一致, 但视觉 (c.16 段 34x34 蓝底白字 4px 圆角) 跟 /all 那个 vendor 默认 (半透明 + 51x46 方形) 不一致
//     + 父链 (c.15 段 main.App-content 内部) 跟 /all 那个 Page-sidebar 内部不一致
//     + ul 包裹 + 隐藏 placeholder (c.17 段) 跟 /all 那个 vendor IndexPage 渲染不一致
//   辉哥 00:17 拍板: "不用保留那 3 段, 预约体验你做成跟发帖按钮一模一样就行, 除了点击时打开预约 modal"
//   修法 (c.19): 回到 c.5 时代 vendor Navigation.items extend 注入路径
//     - 加回 extend(Navigation.prototype, 'items', ...) 段 (跟 c.5 时代一样)
//     - button 走 vendor Button 组件 (自动加 <i icon> + <span Button-label><span Button-labelText>...</span></span> 段)
//     - button className 改 'Button Button--primary IndexPage-newDiscussion hasIcon' (跟 /all 一样, 不要 bjxy-mobile-cta 视觉 class)
//     - button itemclassname="App-primaryControl" 属性 (vendor listItems 内部属性, /all 1:1 一致)
//     - icon 改 'fas fa-calendar-plus' (/all 那个用 'fas fa-edit', 都是 + 表示新建)
//     - children 改 '预约体验' (跟 /all 那个 '开始讨论' 一致)
//     - onclick 改 BookingModal (代替 /all 默认的 IndexPage new discussion flow)
//     - 条件: 只 bjxy 路由 + 只 mobile viewport (桌面端不显示, 跟辉哥 17:06 拍板 A 方案一致)
//   联代性 trade-off (辉哥接受):
//     - c.5 时代 button 走 #app-navigation 内部, iOS 14+ 期间会受 bug 影响 (按钮跑 X/Y 方向偏移)
//     - 辉哥 c.19 拍板接受 /all 一样行为 (虽然 /all 走 main.App-content 不受影响, 但 bjxy 走 #app-navigation 受影响)
//     - 接受 trade-off 优先于继续 18 commits 返工
//   SOP 314 终极方案 (v11): iOS Safari 14+ 移动端顶 bar 适配 = button DOM 跟 /all 1:1 一致 (vendor Navigation.items extend 注入), 接受 iOS 14+ bug trade-off
//   实战教训: 任何项目想在 mobile 端 top bar 右侧加 button, 走 vendor Navigation.items extend 注入 (跟 ziven-theme-aura v0.2.5g 套路一样)
//   适用: 仿 /all "开始讨论" 按钮样式 + 接受 iOS 14+ bug 行为
// 保留 c.18 段思路: button DOM 跟 /all 1:1 (itemclassname + Button-label 段 + icon fa-calendar-plus), 只是渲染路径换回 c.5 时代
// v0.2.0i.aa.c.20 改 (辉哥 2026-09-01 09:26 反馈): 撤 c.19 全部 (vendor Navigation.items extend 注入路径), 改走 c.17 段 (BjxyPage.jsx view() 渲染 ul 包裹 + 隐藏 placeholder 触发 vendor :has + li 走 position: relative 治本 iOS 14+)
//   现象 (辉哥 09:26 反馈): c.19 部署后 iPhone 真机亲测, 下拉刷新过程中 button 还是会跑 X 偏移
//     辉哥反问: "如果真像你说的是完全一致, 为什么 bjxy 页面 top bar 的预约体验在下拉刷新时会向左移动, 而 https://bjxy.top/all 中 top bar 的发帖按钮就不会"
//   根因 (Mavis 排查 /all vs c.19 渲染路径差异):
//     - /all "开始讨论" 按钮走 vendor IndexSidebar.tsx 渲染路径:
//       <nav.IndexPage-nav.sideNav><ul>{listItems(this.items().toArray())}</ul></nav> — listItems helper 包裹每个 item 在 <li> 内
//       L77 classes.push(item.attrs?.itemClassName || item.itemClassName) — 读 button.attrs.itemClassName="App-primaryControl" 加到 li wrapper
//       最终 DOM: ul.IndexPage-nav > li.item-newDiscussion.App-primaryControl > button.IndexPage-newDiscussion.hasIcon
//       ul 内部有 2 个 .App-primaryControl (ziven-aura + vendor newDiscussion), 触发 vendor :has(> .App-primaryControl ~ .App-primaryControl) 选择器
//       ul 走 position: fixed, 子 li 走 position: relative (vendor L74-77 段), iOS 14+ bug 不影响 relative
//     - c.19 按钮走 vendor Navigation.items extend 注入路径:
//       extend(Navigation.prototype, 'items', function (items) { items.add('bjxyBookingCta', <Button ...>) })
//       Navigation.tsx L34: {this.items().toArray()} — items 直接 toArray() 渲染, 不通过 listItems helper
//       最终 DOM: div.Navigation.ButtonGroup > button.Button--primary.IndexPage-newDiscussion.hasIcon.App-primaryControl — 没 li 包裹!
//       没 ul 包裹 → vendor :has 选择器不触发 → button 自己走 vendor L29-37 段 position: fixed → iOS 14+ bug 影响
//   结论: c.19 跟 /all 渲染路径根本不一样, /all 走 IndexSidebar 路径 (listItems 包裹), c.19 走 Navigation 路径 (直接渲染)
//   修法 (c.20 治本 v3): 回到 c.17 段路 c.17 段 (BjxyPage.jsx view() 渲染 ul 包裹 + 隐藏 placeholder 触发 :has + li 走 relative)
//     - 撤 c.19 extend(Navigation.prototype, 'items', ...) 段
//     - 改在 BjxyPage.jsx view() 渲染 <ul class="bjxy-mobile-cta-ul"> 内 <li class="bjxy-mobile-cta-li App-primaryControl item-newDiscussion"> <button class="Button Button--primary IndexPage-newDiscussion hasIcon"> ... </button> </li>
//     - 加 1 个隐藏 placeholder <li class="App-primaryControl" style="display: none"> 触发 vendor :has(> .App-primaryControl ~ .App-primaryControl) 选择器
//       vendor :has 看 DOM 结构, 不看 display 状态, 隐藏 li 仍然触发
//     - button 走 vendor m('button', {...}, [i, span Button-label span Button-labelText]) 节点 (跟 /all 1:1 一样的 DOM 结构)
//     - button 走 main.App-content 内部 (跟 /all 一样父链)
//   联代性 trade-off (辉哥接受):
//     - iOS 14+ 期间 li 不跑 X/Y (main.App-content + relative 不受 bug 影响), .App-backControl (在 #app-navigation 内部) 跑 X
//     - 视觉短暂错位几 ms (跟 /all "开始讨论" 按钮一样行为, 辉哥 iPhone 真机亲测没报这个 bug)
//   条件: 只 bjxy 路由 + 只 mobile viewport (桌面端不显示, 跟辉哥 17:06 拍板 A 方案一致)
//   SOP 314 终极方案 (v12): iOS Safari 14+ 移动端顶 bar 适配 = button 走 main.App-content 内部 (BjxyPage.jsx view() 渲染) + 套 ul 包裹 + 隐藏 placeholder 触发 vendor :has + li 走 position: relative
//   实战教训: 任何项目想在 mobile 端 top bar 右侧加 button, 走 "ul > li > button + 2 个 .App-primaryControl 触发 :has" 套路, 跟 /all 一样
//   适用: 1 个 button 也要套 ul + 隐藏 placeholder, 才能走 vendor L63-78 段 li 走 relative 样式
//   保留 c.18 段: button DOM 跟 /all 1:1 一致 (itemclassname="App-primaryControl" + Button-label 段 + icon fa-calendar-plus)
//   撤 c.19 段: 不再走 vendor Navigation.items extend 注入路径, 改回 c.17 时代 BjxyPage.jsx 渲染
import BjxyPage from './components/BjxyPage';
import BjxyCoachModal from './components/BjxyCoachModal';
import BookingModal from './components/BookingModal';
// v0.2.0ebb16a0.c.f.m.e 加 (辉哥 2026-09-07 11:00 反馈 "预约体验按钮桌面端没有加上, 把它加在桌面端发布主题按钮左侧"):
//   桌面端 HeaderSecondary 注入"预约体验"按钮, priority 49 (ziven-aura-new-discussion 之前 = 左侧), onclick 弹 BookingModal
import modifyHeaderSecondary from './modifyHeaderSecondary';

// v0.2.0i.k.b 新 (辉哥 2026-08-12 17:35 反馈): 劫持 m.route.set + 启动补 push, 解决 /u/{username} 返回按钮 + 刷新跳 /bjxy
//   背景:
//     vendor History 是 session-only 内存, 刷新后 mithril 重建 stack, bjxy entry 丢
//     辉哥实测: 刷新 /u/wfl → stack 变成 [user.posts], 没 bjxy entry, 返回按钮跳 / (首页)
//   修法 3 件套:
//     1) BjxyPage oninit 写 sessionStorage: 'ziven-bjxy-prev-path' = '/bjxy' + 'ziven-bjxy-active' = '1'
//     2) 劫持 m.route.set: 跳 /u/... 时, IF active='1' THEN push bjxy entry
//     3) 启动补 push: initializer 末尾 setTimeout 0, check 当前 url 是 /u/... 且 active='1', push bjxy entry
//   为什么需要 active flag (不是只用 prev-path):
//     防止 /d/1 → /u/ 副作用: 用户没访问过 bjxy, 但劫持无脑 push 会让返回跳 /bjxy 而不是 /d/1
//     active flag 只在 BjxyPage oninit 写, onremove 清, 严格反映"当前 SPA session 内当前路由链是否经过 bjxy"
//   劫持时机 (SOP 2025-08-12 mithril 0.2.x 实战):
//     - bjxy oninit push bjxy entry (stack = [tags, bjxy])
//     - 用户点 /u/wfl link → mithril hijack → 调劫持 m.route.set('/u/wfl')
//     - 我们的劫持: check active='1' (因为 bjxy onremove 还没触发) → push bjxy entry
//     - 调 originalRouteSet → mithril 内部 mount newPage + unmount oldPage (同步)
//     - unmount oldPage: bjxy.onremove() → 清 active='0'
//     - mount newPage: PostsUserPage.oninit → show() push 'user.posts' → stack = [tags, bjxy, user.posts]
//     - canGoBack = true ✅, back() 跳 stack[length-2] = bjxy url = '/bjxy' ✅
//   启动补 push (刷新场景):
//     - 用户刷新 /u/wfl (同 tab, sessionStorage 还在, active='1')
//     - 浏览器新加载 JS, mithril 启动 m.route() 直接 mount default route
//     - mithril 内部 mount PostsUserPage → oninit → show() push 'user.posts' → stack = [tags, user.posts]
//     - 注意: mithril 0.2.x 启动不调 m.route.set, 直接 mount, 所以劫持没被触发 (错过了)
//     - 我们 initializer setTimeout 0 异步 check: 当前 url = /u/wfl, active='1' → push bjxy entry
//     - 异步 push 后 stack = [tags, bjxy, user.posts], backUrl = /bjxy ✅
//   /d/1 → /u/ 场景 (重要!):
//     - 用户在 /d/1, sessionStorage active='0' (没访问过 bjxy)
//     - 点 user 链接 → 劫持 m.route.set('/u/wfl') → check active='0' → 不 push
//     - 走 vendor 默认: stack = [..., 'd/1', 'user.posts'], back 跳 /d/1 ✅
//   跨 tab 场景:
//     - tab A 进 bjxy, tab B 直接打开 /u/wfl
//     - tab B sessionStorage 独立, active='0' → 劫持不 push ✅
//   注意:
//     - 用 global m (Flarum 2.0 注入, 跟 bjxy admin 同款, 跟 vendor patchMithril.js L4 一致)
//     - 劫持只执行一次 (用 closure flag 防止多次 initializer 重入)
//     - 不能改 vendor routes (ForumApplication 改不了), 只能劫持 m.route.set 这个公共 API
const installBjxyRouteHook = () => {
  // 只装一次, 防止 HMR / 多次 initializer 重复 patch
  if (window.__zivenBjxyRouteHookInstalled) return;
  window.__zivenBjxyRouteHookInstalled = true;
  const originalRouteSet = m.route.set.bind(m.route);
  m.route.set = function (path, params, options) {
    // 只在跳 /u/{username} 用户页面时插桩 (其他路径不影响)
    if (typeof path === 'string' && path.indexOf('/u/') === 0) {
      try {
        const active = sessionStorage.getItem('ziven-bjxy-active');
        const bjxyPrev = sessionStorage.getItem('ziven-bjxy-prev-path');
        // 三重 check 防 /d/1 → /u/ 副作用:
        //   1. active='1' (用户在 SPA session 内访问过 bjxy)
        //   2. bjxyPrev 存在
        //   3. app.previous 是 bjxy 路径 (m.route.set 之前 mithril 内部已 setPrevious)
        //   关键: sessionStorage 跨 page.goto 持续, 单独用 active 没法区分 /d/1 → /u/ (用户没访问过 bjxy 但 active='1' 还在)
        //   app.previous 是 mithril 0.2.x 内部 PageState 跟踪上一路由, 在 m.route.set 调用时已更新
        //   如果 app.previous routeName='bjxy', 说明用户真的是从 bjxy 跳过来的
        //   如果 app.previous 是其他 (e.g. 'discussion'), 说明用户从其他页面来, 不该 push bjxy entry
        // 注意: app.previous 可能是 undefined (第一次 mount), 这时不 push
        if (active === '1' && bjxyPrev && app && app.history && app.previous && app.previous.get && app.previous.get('routeName') === 'bjxy') {
          // push 'bjxy' entry, History.push L57-58 检查 top 同名会覆盖, 不会 stack 重复
          app.history.push('bjxy', 'bjxy 官网', bjxyPrev);
        }
      } catch (e) {
        // sessionStorage 禁用 (隐私模式), 静默失败
      }

      // v0.2.0ebb16a0.c.f.n (辉哥 2026-09-09 16:30 反馈 "进入用户页面后默认展示讨论"):
      //   决定走路由覆盖方案: 不劫持 m.route.set (因为 mithril boot 不调 m.route.set,
      //   劫持错过初次 mount), 而是在 initializer 里覆盖 app.routes.user.component =
      //   DiscussionsUserPage, 让 /u/{username} 默认渲染讨论列表
      //   老的劫持代码 (下面的 userPathMatch 改写) 撤回, 避免跟路由覆盖双触发
      //
      //   老的尝试代码 (撤回, v0.2.0ebb16a0.c.f.n.a):
      //     const userPathMatch = path.match(/^\/u\/([^/]+)$/);
      //     if (userPathMatch) {
      //       path = `/u/${userPathMatch[1]}/discussions`;
      //     }
      //   撤回原因 (辉哥 9/9 16:30 + 16:35 反馈 Puppeteer 验证):
      //     - mithril boot 同步 mount vendor default route, 不调 m.route.set
      //     - setTimeout 0 调 m.route.set 又被 vendor route resolve 走 user route (不是 user.discussions)
      //     - 最后 URL 仍是 /u/Ziven 但内部 content 被 mount 两遍
      //   修法: 走路由覆盖, 同步 import DiscussionsUserPage, initializer 覆盖 app.routes.user.component
    }
    return originalRouteSet(path, params, options);
  };
};
const maybePushBjxyOnBoot = () => {
  // 启动补 push: 刷新 /u/{username} 场景, mithril 0.2.x 启动不调 m.route.set, 劫持错过
  // setTimeout 0 让 mithril 同步 mount 完成 (PostsUserPage.oninit + show + push user.posts) 后再补 push
  // 关键: splice 插入到 stack 倒数第 2 个位置 (user.posts 之前), 不能简单 push 否则 backUrl 错误
  //   错误: 简单 push → stack = [..., 'user.posts', 'bjxy'] → backUrl = '/u/wfl' (错!)
  //   正确: splice 插入 → stack = [..., 'bjxy', 'user.posts'] → backUrl = '/bjxy' (对)
  // 二次 check 防 /d/1 → /u/ 副作用 (跟劫持逻辑一致, 三重 check)
  // 特殊 case: 刷新 /u/{username} 场景, app.previous 是 null (第一次 mount), 走 noPrevious 路径
  setTimeout(() => {
    try {
      const active = sessionStorage.getItem('ziven-bjxy-active');
      const bjxyPrev = sessionStorage.getItem('ziven-bjxy-prev-path');
      const currentPath = window.location.pathname;
      const isUserPage = currentPath.indexOf('/u/') === 0;
      // 场景 A: /u/ 路径 + 正常 previous 链 (SPA 内跳转) — app.previous='bjxy'
      // 场景 B: /u/ 路径 + 无 previous (刷新场景) — app.previous 是 null/undefined
      // 场景 C: 非 /u/ 路径 — 不补 push
      if (!isUserPage) return;
      if (!active || active !== '1' || !bjxyPrev || !app || !app.history) return;
      const previousRoute = app.previous && app.previous.get ? app.previous.get('routeName') : null;
      const isFromBjxy = previousRoute === 'bjxy';
      const isFreshLoad = !previousRoute; // 第一次 mount (刷新场景)
      // 场景 C 防误伤: 是 /u/ 路径但 previous 是 'tags' 或 'discussion' 等其他 (e.g. /d/1 跨 page 跳过来的 mithril 启动)
      //   但这种情况 setTimeout 0 跑时, currentPath 应该是 /d/1 不是 /u/, 已经 return 了
      //   所以 isFromBjxy || isFreshLoad 就够了
      if (!isFromBjxy && !isFreshLoad) return;
      const stack = app.history.stack;
      if (stack && stack.length > 0) {
        // 已经在倒数第 2 个位置是 bjxy (幂等) 就跳过
        if (stack.length >= 2 && stack[stack.length - 2].name === 'bjxy') return;
        // 用 splice 把 bjxy entry 插入到栈顶前面 (length-1 位置)
        stack.splice(stack.length - 1, 0, {
          name: 'bjxy',
          url: bjxyPrev,
          title: 'bjxy 官网'
        });
      }
    } catch (e) {
      // 静默失败
    }
  }, 0);
};

// v0.2.0k (辉哥 2026-09-04 08:25 反馈, 续 v0.2.0j.b server-side 修复): SPA 路由切换 client-side meta tag 同步
//   根因: bjxy extend v0.2.0j.b 修了 server-side HTML 渲染 (curl 抓的 HTML og:url 跟 URL 一致),
//     但 Flarum 2.0 SPA 模式 client-side 路由切换不重新渲染 HTML, head meta tags 不会更新
//     - 用户在 bjxy.top 看到 bjxy 页面, 点页面内链接跳到 /all, mithril 走 history.pushState
//     - 浏览器 URL bar 变成 /all, 但 page DOM 里的 <meta property="og:url"> 还停留 bjxy.top
//     - 用户复制 URL (浏览器地址栏) 是 /all (对的)
//       但用 bjxy 自己的"分享"按钮 (如果装) 或微信爬虫抓当前 page DOM 时, 读 og:url = bjxy.top (stale)
//     - 分享出去 = bjxy.top, 不是当前实际页面 URL
//   修法: 监听 SPA 路由变化, 每次 pushState/replaceState/popstate 后更新 head meta tags 到当前 window.location.href
//     - updateMeta(url) 改 3 个 selector: meta[property="og:url"] / meta[name="twitter:url"] / link[rel="canonical"]
//     - 监听 3 个事件: popstate (back/forward) + pushState override (m.route.set) + replaceState override (m.route.replace)
//     - setTimeout 0 等 mithril 同步完成 (跟 maybePushBjxyOnBoot 同款)
//     - 初次跑一次 (initializer 时机已渲染 server HTML, og:url = initial URL)
//   跟 v0.2.0j.b 关系: server-side 修初次访问 (curl/HTTP 抓的 HTML 正确), client-side 修 SPA 切换 (DOM meta 跟 URL 同步)
//     两个一起, 任何访问方式 (curl / 浏览器 / 微信爬虫 / 复制 URL) 都能拿到正确 URL
//   ⏳ 待辉哥 iPhone 真机亲测: 任何 SPA 路由切换后分享 = 当前 URL
const installSpaOgMetaUpdater = () => {
  if (window.__bjxySpaOgMetaInstalled) return;
  window.__bjxySpaOgMetaInstalled = true;
  const updateMeta = url => {
    try {
      // 更新所有 meta[property="og:url"] 的 content (v0.2.0j.b 推的 + fof-seo 推的, 都更新到当前 URL)
      document.querySelectorAll('meta[property="og:url"]').forEach(el => el.setAttribute('content', url));
      document.querySelectorAll('meta[name="twitter:url"]').forEach(el => el.setAttribute('content', url));
      // 更新 link[rel="canonical"] 的 href (v0.2.0j.b 覆盖 canonicalUrl 推到这, 现在也跟 URL 同步)
      document.querySelectorAll('link[rel="canonical"]').forEach(el => el.setAttribute('href', url));
    } catch (e) {
      // 静默失败
    }
  };

  // 初次跑一次 (initializer 时机已渲染 server HTML)
  updateMeta(window.location.href);

  // 监听 popstate (浏览器 back/forward)
  window.addEventListener('popstate', () => {
    setTimeout(() => updateMeta(window.location.href), 0);
  });

  // Override pushState (m.route.set 走 history.pushState)
  const originalPushState = history.pushState;
  history.pushState = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const result = originalPushState.apply(this, args);
    setTimeout(() => updateMeta(window.location.href), 0);
    return result;
  };

  // Override replaceState (m.route.replace 走 history.replaceState)
  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    const result = originalReplaceState.apply(this, args);
    setTimeout(() => updateMeta(window.location.href), 0);
    return result;
  };
};
app.initializers.add('ziven-bjxy-website', () => {
  // v0.2.0i.k.b: 在 initializer 启动时装 m.route.set 劫持 + 启动补 push
  //   initializer 在 forum JS bundle 启动时执行一次, 时机早于任何 component mount
  installBjxyRouteHook();
  maybePushBjxyOnBoot();
  // v0.2.0k: SPA 路由切换同步 client-side meta tags 到当前 URL
  installSpaOgMetaUpdater();
  // v0.2.0i.aa.logo (辉哥 2026-09-03 21:48 拍板): logo 修改已迁到 ziven-theme-aura (installBjxyHeaderLogo 删除, 配套 less 段也删)
  //   原因: logo 是主题范畴, 不应该耦合在 bjxy 扩展里
  //   ziven-theme-aura modifyHeaderLogo.js 通用化处理, 任何 ziven 项目 (bjxy_brand_logo_url setting) 都生效
  app.routes.bjxy = {
    path: '/bjxy',
    component: BjxyPage
  };
  app.bjxyCoachModal = BjxyCoachModal;
  // v0.2.0ebb16a0.c.f.m.e 加 (辉哥 9/7 11:00): 桌面端顶部加"预约体验"按钮
  modifyHeaderSecondary();
  // v0.2.0ebb16a0.c.f.n + c.f.p + c.f.q (辉哥 2026-09-09 16:30 / 18:14 / 18:46 三段反馈) 已在 9/9 19:25
  //   迁到 ziven-core v0.5.16 (modifyUserPage.js): 默认用户页显示讨论 + 隐藏回复 tab 给非 admin/mod
  //   + mobile top bar 强制显示当前 active tab 文字 + admin 端强制 posts.active=false
  //   本扩展不再有 UserPage 相关代码, 由 ziven-core boot 时统一应用
});